/*
* Overview of available enums: https://gitlab.com/digital-pharma-dp3/pharma-customer-product-catalog/-/tree/master/application/src/Model/Enum
*/
export enum EnumClassNamePimEnum {
    TEXT_FRAGMENT_NAME = "App\\Model\\Enum\\Pim\\TextFragmentNameEnum",
    PIM_PRODUCT_FIELD = "App\\Model\\Enum\\Pim\\PimProductFieldEnum",
    PIM_TRADEMARK = "App\\Model\\Entity\\Pim\\DenumProductTrademark",
    PIM_TARGET_GROUP = "App\\Model\\Entity\\Pim\\DenumTargetGroup",
    PIM_UNIT = "App\\Model\\Entity\\Pim\\DenumUnit",
}
